var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 12 13"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#4E4E4E",
  strokeLinecap: "round",
  strokeWidth: 1.25,
  d: "M3 6.5h6m0 0-2-2m2 2-2 2"
})));
export default SvgArrowRight;